<template>
  <layout-base
    id="gtr-lead-weekly"
    style="font-family: 'Poppins', sans-serif; font-size: 14px; text-align:center;"
    align="center"
    margin="20px 14px 0px 14px"
  >
    <div style="text-align: left;">
      <lpe-report-intro :pending="email.data.PENDING" :processing="email.data.PROCESSING" :user="email.data.USER" />
      <hr
        style="display: block; height: 0.5px; border: 0; border-top: 1px solid #D2D2D2; margin-bottom: 28px;"
        width="80%"
      />

      <div style="font-size: 15px; font-weight: 700;">{{ $t('leadWeekly.heading.previousWeek') }}</div>
      <div
        style="display: grid; grid-template-columns: repeat(3, 1fr); gap: 12px; justify-items: center; margin: 20px 0 28px 0"
      >
        <lpe-report-block :infos="email.data.TOTAL" name="GENERATED" />
        <lpe-report-block :infos="email.data.CONVERTED" name="CONVERTED" bg-color="#53B027" />
        <lpe-report-block :infos="email.data.LOST" name="LOST" bg-color="#D61717" />
      </div>
      <hr
        style="display: block; height: 0.5px; border: 0; border-top: 1px solid #D2D2D2; margin-bottom: 28px;"
        width="80%"
      />

      <div style="font-size: 16px; font-weight: 700; margin-bottom: 20px;">
        {{ $t('leadWeekly.heading.topProduct') }}
      </div>
      <lpe-report-array :items="email.data.TOP_PRODUCT_GENERATED" name="Generated" />
      <lpe-report-array style="margin: 12px 0 24px 0" :items="email.data.TOP_PRODUCT_SOLD" name="Sold" />
      <hr
        style="display: block; height: 0.5px; border: 0; border-top: 1px solid #D2D2D2; margin-bottom: 28px;"
        width="80%"
      />

      <div style="font-size: 16px; font-weight: 700; margin-bottom: 20px;">{{ $t('leadWeekly.heading.business') }}</div>
      <lpe-report-array :items="email.data.TOP_DEALER" />
      <div style="text-align: center; margin: 38px 0;">
        <a
          href="https://app-v2.gtrsuite.com/network/leads/tabs/dashboard"
          target="_blank"
          style="background: #53B027; border-radius: 30px; padding: 10px 15px; text-align: center; text-decoration: none; color: white; font-weight: 600;"
        >
          {{ $t('leadWeekly.button.dashboard') }}
        </a>
      </div>

      <lpe-report-footer />
    </div>
  </layout-base>
</template>

<script>
import LayoutBase from '@/components/Layout/Base.vue'
import LpeReportIntro from '@/components/Lpe/Report/Intro.vue'
import LpeReportBlock from '@/components/Lpe/Report/Block.vue'
import LpeReportArray from '@/components/Lpe/Report/Array.vue'
import LpeReportFooter from '@/components/Lpe/Report/Footer.vue'

export default {
  name: 'LpeReportLeadWeekly',
  components: {
    LayoutBase,
    LpeReportIntro,
    LpeReportBlock,
    LpeReportArray,
    LpeReportFooter,
  },
  props: {
    email: {
      type: Object,
      required: true,
    },
  },
}
</script>
